import { render, staticRenderFns } from "./LanguageMultiselect.vue?vue&type=template&id=c5d43b0a&scoped=true&"
import script from "./LanguageMultiselect.vue?vue&type=script&lang=js&"
export * from "./LanguageMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d43b0a",
  null
  
)

export default component.exports